import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import type { AdminRouterContext } from '@/context/AdminRouterContext'
import * as Sentry from "@sentry/react";
import { StandardErrorDisplay } from '@/components/shared/StandardErrorDisplay';

export const Route = createRootRouteWithContext<AdminRouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
  errorComponent: ({ error }) => {
    Sentry.captureException(error);
    return (
      <StandardErrorDisplay 
        error={error}
        onRetry={() => window.location.reload()}
      />
    );
  },
})